import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({
  name: 'FormatDate'
})
export class FormatDate implements PipeTransform {

  transform(date: string): string {

    if (date) {
      return moment(date).format("DD/MM/YYYY HH:mm")
    }

    return "";
  }

}
